<template>
  <div class="d-flex flex-column flex-grow-1">
    <div>
      <div class="display-1">RFQ</div>
      <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
    </div>

    <DealerRFQList
      :rfqList="rfqList"
      :pagination-obj="pagination ? pagination : null"
      @refresh="loadDealerRFQ"
      @paginate="paginateRFQs"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import DealerRFQList from "@/components/rfq/DealerRFQList";
export default {
  components: {
    DealerRFQList
  },
  computed: {
    ...mapState({
      rfqs: store => store.rfq.rfqs
    }),
    rfqList() {
      return this.rfqs ? this.rfqs.RFQ : [];
    },
    pagination() {
      return this.rfqs && this.rfqs.pagination ? this.rfqs.pagination : null;
    }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Login",
          disabled: true,
          href: "/login"
        },
        {
          text: "RFQ"
        }
      ]
    };
  },
  created() {
    this.loadDealerRFQ();
  },
  methods: {
    async loadDealerRFQ(payload = null) {
      this.addModal = false;
      this.isLoading = true;
      let loader = this.$loading.show();
      await this.$store.dispatch("rfq/getDealerRFQ", payload).finally(() => {
        this.isLoading = false;
        loader.hide();
      });
    },
    paginateRFQs(value) {
      this.loadDealerRFQ({ page: value });
    }
  }
};
</script>
